import { BrandingConfig } from '../../types/profile';

export function applyThemeTokens(branding: BrandingConfig): void {
  const root = document.documentElement;
  root.style.setProperty('--brand-bg', branding.backgroundColor);
  root.style.setProperty('--brand-card', branding.cardBackgroundColor);
  root.style.setProperty('--brand-border', branding.borderColor);
  root.style.setProperty('--brand-primary', branding.primaryColor);
  root.style.setProperty('--brand-primary-glow', branding.primaryGlowColor);
  root.style.setProperty('--brand-accent-gold', branding.accentGoldColor);
  root.style.setProperty('--brand-accent-green', branding.accentGreenColor);
  root.style.setProperty('--brand-accent-purple', branding.accentPurpleColor);
  root.style.setProperty('--brand-text', branding.textColor);
  root.style.setProperty('--brand-muted', branding.mutedTextColor);
  root.style.setProperty('--brand-radius', branding.borderRadius);

  // Background gradient dynamic styling
  document.body.style.backgroundColor = branding.backgroundColor;
}

